import { TextInput } from "@mantine/core";
import Label from "../atom/Label";

const FormField = ({ label, required, ...inputProps }) => (
  <div className="w-full mb-4">
    <Label>
      {label} {required && <span className="text-red-500">*</span>}
    </Label>
    <TextInput required={required} {...inputProps} className="w-full" />
  </div>
);

export default FormField;
